<template>
    <div class="h-100">
      <Container>
        <router-view/>
      </Container>
    </div>
</template>

<script>
import Container from './components/layout/Container.vue';
import { mapActions, mapMutations, mapState } from 'vuex';
import Echo from 'laravel-echo';
require('pusher-js');

export default {
    name: 'app',
    data() {
        return {
            echo: null
        };
    },
    components: {
        Container
    },
    computed: {
        ...mapState('users', ['user'])
    },
    methods: {
        ...mapActions('messages', ['getUnreadCount']),
        ...mapMutations('messages', ['addMessage'])
    },
    created: function() {
        this.echo = new Echo({
            broadcaster: 'pusher',
            key: 'd0398536e21e83642254',
            cluster: 'us2',
            encrypted: true
        });

        if (this.$auth.check()) {
            this.getUnreadCount();

            this.echo
                .channel(`App.User.${this.user.id}`)
                .listen('.message', e => {
                    this.addMessage(e.message);
                });
        }
    }
};
</script>

<style>
@import './assets/css/tachyons/css/tachyons.min.css';
@import './assets/css/flexboxgrid/dist/flexboxgrid.min.css';
@import './assets/css/design-css.css';
@import '../node_modules/pretty-checkbox/dist/pretty-checkbox.min.css';
</style>
